import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { transferDiscountDetails } from '@/mocks/pricingDetailsData';

export default function TransferDiscount() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-primary-900">
      <div className="max-w-[900px] mx-auto px-8">
        <div className="text-center mb-14">
          {String(t('pricingDetails.transfer.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-400 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-50 tracking-[0.06em] mb-2">
            {t('pricingDetails.transfer.title')}
          </h2>
          {String(t('pricingDetails.transfer.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-400 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
          {String(t('pricingDetails.transfer.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] md:text-[16px] text-foreground-300 tracking-[0.04em] leading-relaxed mt-6 max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        <div className="flex flex-col md:flex-row gap-6 mb-10">
          {transferDiscountDetails.discounts.map((discount, idx) => (
            <div
              key={idx}
              className="card-glow flex-1 border border-primary-700/40 bg-primary-800/30 p-6 md:p-8"
            >
              <div className="flex items-center gap-3 mb-5">
                <div className="w-9 h-9 flex items-center justify-center bg-accent-500/15 rounded-full flex-shrink-0">
                  <i className="ri-arrow-right-up-line text-accent-400 text-base"></i>
                </div>
                <div>
                  <p className="text-[13px] text-primary-300 tracking-[0.05em]">
                    {lang === 'en' ? t(`pricingDetails.transferDetail.${idx}.from`) : discount.from}
                  </p>
                  <div className="flex items-center gap-1">
                    <i className="ri-arrow-down-line text-accent-400 text-xs"></i>
                    <p className="text-[14px] text-foreground-100 tracking-[0.05em] font-medium">
                      {lang === 'en' ? t(`pricingDetails.transferDetail.${idx}.to`) : discount.to}
                    </p>
                  </div>
                </div>
              </div>

              <div className="text-center py-3 mb-3 border-y border-primary-700/30">
                <span className="text-[22px] text-accent-400 tracking-[0.06em] font-medium">
                  &#x25B2;{parseInt(discount.amount).toLocaleString()} {t('pricingDetails.transfer.discount')}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-[650px] mx-auto p-5 border border-primary-700/40 bg-primary-800/20">
          <div className="flex items-start gap-3">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-accent-400 text-sm"></i>
            </div>
            <div>
              {String(t('pricingDetails.transfer.note')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-300 tracking-[0.04em] leading-relaxed mb-2">{__s}</p>))}
              <Link
                to="/consultation"
                className="text-[14px] text-accent-400 hover:text-accent-300 tracking-[0.04em] transition-colors underline underline-offset-2"
              >
                {t('pricingDetails.transfer.consultLink')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
